// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".schedule-status[data-v-5b3f2324]{align-items:center;display:flex;height:21px;padding:0 4px}.schedule-status.contained[data-v-5b3f2324]{background-color:#ec514f;color:#fff}.schedule-status.outlined[data-v-5b3f2324]{background-color:#fff;color:#ec514f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
